import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

class BackorderService{

    getBackorders(token,lingua){
        return axios({
            method: 'get',
            url: API_URL + 'Backorder/GetBackorders', 
            params: {
                codiceLingua: lingua
            },            
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }               
            }
        )
        .catch(error => {return error;});            
    }
}

export default new BackorderService();